<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation>
        <v-card class="insights-dialog">
          <v-card-title>
            <span class="headline"><v-icon class="pr-2">add_circle_outline</v-icon>Competitors list</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>

                <v-flex xs18 sm9 md6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="form.date"
                      label="Date*"
                      prepend-icon="event"
                      readonly
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-date-picker v-model="form.date"
                                   @input="menu = false"
                                   min="1990-01-01"
                                   :max=currentDate
                                   required
                                   no-title></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs18 sm9 md6>
                  <v-text-field label="Top*"
                                v-model="form.top"
                                persistent-hint
                                :rules="[rules.required, rules.isNumber, rules.numberSize]"
                                required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Domain*"
                                v-model="form.domain"
                                hint="www.example.com or example.com"
                                :rules="[rules.required, rules.domainName]"
                                required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="form.keywords"
                    label="Keywords"
                    hint="Enter keywords one per line or separated by commas"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="form.competitors"
                    label="Competitors"
                    hint="Enter competitors one per line or separated by commas"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="form.engine_id"
                    :items="selectEngine"
                    item-text="name"
                    item-value="id"
                    label="Search engine*"
                    required
                    data-vv-name="add_project.engine_id"
                    :error-messages="errors.collect('add_project.engine_id')"
                  >
                    <template slot="item" slot-scope="data">
                      <v-icon class="pr-2 engine-flag-icon">{{ data.item.country_css }}</v-icon>
                      <v-icon class="pr-2 engine-device-icon">{{ data.item.device_css }}</v-icon>
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="form.sendEmail"
                    color="primary"
                    label="Email me when report is ready"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <span><v-icon class="pr-2">info</v-icon> Reports are usually generated within a few minutes. However, it can take longer based on the date range selected.</span>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-on:click="closeDialog" color="blue darken-1" flat>Close</v-btn>
            <v-btn v-on:click="validate" color="blue darken-1" flat>Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import InsightMixin from '../../mixins/insightMixin'

export default {
  name: 'competitors-list',
  props: {
    dialog: {
      default: false,
      type: Boolean
    },
    maxTop: {
      default: 100,
      type: Number
    }
  },
  mixins: [InsightMixin],
  data () {
    return {
      name: 'competitors-list',
      form: {
        date: new Date().toISOString().substr(0, 10),
        top: 100,
        domain: '',
        sendEmail: true,
        keywords: '',
        competitors: '',
        engine_id: 1
      },
      result: {
        type: 0,
        date: new Date().toISOString().substr(0, 10),
        params: {
          top: 100,
          domain: '',
          send_email: true,
          keywords: [],
          competitors: [],
          engine_id: 1
        }
      },
      currentDate: new Date().toISOString().substr(0, 10),
      menu: false
    }
  },
  methods: {
    formToResult () {
      this.result.date = this.form.date
      this.result.params.top = this.form.top
      this.result.params.domain = this.form.domain
      this.result.params.send_email = this.form.sendEmail
      this.result.params.keywords = this.stringToArray(this.form.keywords)
      this.result.params.competitors = this.stringToArray(this.form.competitors)
      this.result.params.engine_id = this.form.engine_id
    },
    resetForm () {
      this.form = {
        date: new Date().toISOString().substr(0, 10),
        top: 100,
        domain: '',
        sendEmail: true,
        keywords: '',
        competitors: '',
        engine_id: 1
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/insights-dialog/CompetitorsList.vue